export const UPDATE_HIERARCHY = "UPDATE_HIERARCHY";
export const UPDATE_NAME_EN = "UPDATE_NAME_EN";
export const UPDATE_NAME_JA = "UPDATE_NAME_JA";
